"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StyledSpan = exports.StyledLabel = exports.StyledIcon = exports.StyledButton = exports.LoadingIcon = void 0;

var _taggedTemplateLiteral2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteral"));

var _styledComponents = _interopRequireWildcard(require("styled-components"));

var _styledSystem = require("styled-system");

var _utils = require("../lib/utils");

var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5, _templateObject6, _templateObject7, _templateObject8, _templateObject9, _templateObject10, _templateObject11;

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var typeColorMap = {
  primary: {
    "default": function _default(props) {
      return (0, _utils.getPalette)('primary', '300')(props);
    },
    hover: function hover(props) {
      return (0, _utils.getPalette)('primary', '400')(props);
    },
    disabled: function disabled(props) {
      return (0, _utils.getPalette)('light', '400')(props);
    },
    selected: function selected(props) {
      return (0, _utils.getPalette)('primary', '500')(props);
    }
  },
  secondary: {
    "default": function _default(props) {
      return (0, _utils.getPalette)('grey', '800')(props);
    },
    hover: function hover(props) {
      return (0, _utils.getPalette)('grey', '900')(props);
    },
    disabled: function disabled(props) {
      return (0, _utils.getPalette)('dark', '300')(props);
    },
    selected: function selected(props) {
      return (0, _utils.getPalette)('grey', '700')(props);
    }
  },
  text: {
    "default": 'transparent',
    hover: function hover(props) {
      return (0, _utils.getPalette)('primary', '100')(props);
    },
    disabled: 'transparent',
    selected: function selected(props) {
      return (0, _utils.getPalette)('white', '700')(props);
    }
  }
};
var sizes = {
  small: (0, _styledComponents.css)(_templateObject || (_templateObject = (0, _taggedTemplateLiteral2["default"])(["\n    height: 32px;\n  "]))),
  medium: (0, _styledComponents.css)(_templateObject2 || (_templateObject2 = (0, _taggedTemplateLiteral2["default"])(["\n    height: 40px;\n  "]))),
  large: (0, _styledComponents.css)(_templateObject3 || (_templateObject3 = (0, _taggedTemplateLiteral2["default"])(["\n    height: 48px;\n  "])))
};
var variants = {
  fill: (0, _styledComponents.css)(_templateObject4 || (_templateObject4 = (0, _taggedTemplateLiteral2["default"])(["\n    border-color: transparent;\n    border-width: 0px;\n    color: ", ";\n    background-color: ", ";\n    &:hover {\n      color: ", ";\n      background-color: ", ";\n    }\n    ", "\n  "])), function (props) {
    return props.color !== 'text' ? (0, _utils.getPalette)('white', '900')(props) : props.disabled ? (0, _utils.getPalette)('dark', '300')(props) : (0, _utils.getPalette)('primary', '300')(props);
  }, function (props) {
    return props.disabled ? typeColorMap[props.color].disabled : props.isSelected ? typeColorMap[props.color].selected : typeColorMap[props.color]["default"];
  }, function (props) {
    return props.color !== 'text' ? (0, _utils.getPalette)('white', '900')(props) : props.disabled ? (0, _utils.getPalette)('dark', '300')(props) : (0, _utils.getPalette)('primary', '400')(props);
  }, function (props) {
    return props.disabled ? typeColorMap[props.color].disabled : props.isSelected ? typeColorMap[props.color].selected : typeColorMap[props.color].hover;
  }, function (props) {
    return props.disabled && "\n      color: ".concat((0, _utils.getPalette)('dark', '300')(props), " !important;\n    ");
  }),
  outlined: (0, _styledComponents.css)(_templateObject5 || (_templateObject5 = (0, _taggedTemplateLiteral2["default"])(["\n    background-color: transparent;\n    border-color: ", ";\n    color: ", ";\n    &:hover {\n      border-color: ", ";\n      color: ", ";\n    }\n    ", "\n  "])), function (props) {
    return props.disabled ? typeColorMap[props.color].disabled : props.isSelected ? typeColorMap[props.color].selected : typeColorMap[props.color]["default"];
  }, function (props) {
    return props.disabled ? typeColorMap[props.color].disabled : props.isSelected ? typeColorMap[props.color].selected : typeColorMap[props.color]["default"];
  }, function (props) {
    return props.disabled ? typeColorMap[props.color].disabled : props.isSelected ? typeColorMap[props.color].selected : typeColorMap[props.color].hover;
  }, function (props) {
    return props.disabled ? typeColorMap[props.color].disabled : props.isSelected ? typeColorMap[props.color].selected : typeColorMap[props.color].hover;
  }, function (props) {
    return props.disabled && "\n      color: ".concat((0, _utils.getPalette)('dark', '300')(props), " !important;\n      border-color: ").concat((0, _utils.getPalette)('dark', '300')(props), " !important;\n    ");
  })
};
var buttonStyle = (0, _styledComponents.css)(_templateObject6 || (_templateObject6 = (0, _taggedTemplateLiteral2["default"])(["\n  -webkit-font-smoothing: antialiased;\n  display: inline-block;\n  vertical-align: middle;\n  text-align: center;\n  text-decoration: none;\n  border-width: 1px;\n  border-style: solid;\n  cursor: pointer;\n  display: inline-flex;\n  align-items: center;\n  box-sizing: border-box;\n  justify-content: center;\n  padding-left: 12px;\n  padding-right: 12px;\n  transition: background 0.2s ease-in-out;\n  ", "\n  border-radius: 4px;\n\n  ", "\n  ", "\n  ", ";\n  ", ";\n\n  &:disabled {\n    cursor: not-allowed;\n  }\n"])), function (props) {
  return (0, _utils.getTypography)('body2')(props);
}, function (props) {
  return sizes[props.size];
}, function (props) {
  return variants[props.variant];
}, _styledSystem.width, _styledSystem.space);

var StyledButton = _styledComponents["default"].button(_templateObject7 || (_templateObject7 = (0, _taggedTemplateLiteral2["default"])(["\n  ", "\n"])), buttonStyle);

exports.StyledButton = StyledButton;

var StyledSpan = _styledComponents["default"].span(_templateObject8 || (_templateObject8 = (0, _taggedTemplateLiteral2["default"])(["\n  ", "\n"])), buttonStyle);

exports.StyledSpan = StyledSpan;

var StyledLabel = _styledComponents["default"].span(_templateObject9 || (_templateObject9 = (0, _taggedTemplateLiteral2["default"])(["\n  vertical-align: middle;\n  position: relative;\n"])));

exports.StyledLabel = StyledLabel;

var StyledIcon = _styledComponents["default"].span(_templateObject10 || (_templateObject10 = (0, _taggedTemplateLiteral2["default"])(["\n  ", "\n  ", "\n"])), function (props) {
  return props.hasIconLeft && "\n    margin-right: 8px\n    ";
}, function (props) {
  return props.hasIconRight && "\n    margin-left: 8px\n  ";
});

exports.StyledIcon = StyledIcon;

var LoadingIcon = _styledComponents["default"].span(_templateObject11 || (_templateObject11 = (0, _taggedTemplateLiteral2["default"])(["\n  svg {\n    -webkit-animation: spin 1s linear infinite;\n    -moz-animation: spin 1s linear infinite;\n    animation: spin 1s linear infinite;\n  }\n  @-moz-keyframes spin {\n    100% {\n      -moz-transform: rotate(360deg);\n    }\n  }\n  @-webkit-keyframes spin {\n    100% {\n      -webkit-transform: rotate(360deg);\n    }\n  }\n  @keyframes spin {\n    100% {\n      -webkit-transform: rotate(360deg);\n      transform: rotate(360deg);\n    }\n  }\n"])));

exports.LoadingIcon = LoadingIcon;